module.exports = __webpack_public_path__ + "static/media/TrafficLight.f77da091.less";


//////////////////
// WEBPACK FOOTER
// ./src/components/TrafficLight.less
// module id = 3180
// module chunks = 0